<fui-inline-fascia (clicked$)="click()" [disabled]="disabled" [focussed]="focussed" [hovered]="hovered"
                   [ngClass]="'clickable'">
    <fui-fixtures>
        <fui-fixture *ngIf="!disabled">
            <fui-mark-toggle [toggled]="popped">
                <fui-icon [height]="12" [icon]="'chevron-down'" [width]="12"></fui-icon>
            </fui-mark-toggle>
        </fui-fixture>
        <fui-spanning-fixture>
            <fui-input-dom *ngIf="!disabled || !selections || !selections.length || !optionOpenable">
                <input (blur)="onBlur($event)" #input (focus)="onFocus($event)" [ngModel]="selected"
                       [placeholder]="placeholder | translate" [readonly]="true" [tabindex]="tabindex" type="text">
            </fui-input-dom>
            <div *ngIf="disabled && selections && selections.length && optionOpenable" class="multiselect-links">
                <span *ngFor="let selection of selections" class="multiselect-links-link">
                    <span class="multiselect-links-link-text"
                          (click)="openOption($event, selection)">{{selection[key]}}</span>
                </span>
            </div>
        </fui-spanning-fixture>
        <fui-fixture *ngIf="validateable">
            <fui-validations [control]="control" [focussed]="focussed"></fui-validations>
        </fui-fixture>
        <fui-fixture *ngIf="notation">
            <fui-notation [title]="notation"></fui-notation>
        </fui-fixture>
    </fui-fixtures>
</fui-inline-fascia>
<fui-select-pop [popped]="popped" (popped$)="pop($event)">
    <fui-sections>
        <fui-content-section *ngIf="loading && !query">
            <fui-loading>
                <fui-ellipsis-loader></fui-ellipsis-loader>
            </fui-loading>
        </fui-content-section>
        <fui-fab-section *ngIf="searchable()">
            <fui-search-control [label]="'fui.select-control.label.filter' | translate" [(ngModel)]="query"
                                [placeholder]="'fui.select-control.placeholder.filter' | translate"></fui-search-control>
        </fui-fab-section>
        <fui-list-section *ngIf="filled(selections)">
            <fui-multiselect-options [field]="field" [key]="key" [filteredOptions]="selections" id="selections"
                                     [optionOpenable]="optionOpenable"
                                     (optionOpened$)="optionOpened$.emit($event)"
                                     (changeSelections$)="select($event)">
                <fui-clear-button [title]="'fui.select-control.label.clearSelected'"
                                  (click)="clearSelection($event)"></fui-clear-button>
            </fui-multiselect-options>
        </fui-list-section>
        <fui-content-section *ngIf="empty(filteredOptions) && empty(selections)">
            <fui-empty>
                <fui-icon [height]="32" [icon]="'search-group'" [width]="32"></fui-icon>
            </fui-empty>
        </fui-content-section>
        <fui-content-section *ngIf="filled(filteredOptions)">
            <fui-fragments>
                <fui-fragment>
                    <fui-multiselect-options [field]="field" [key]="key" [filteredOptions]="filteredOptions" id="options"
                                             [optionOpenable]="optionOpenable"
                                             (optionOpened$)="optionOpened$.emit($event)"
                                             [allowLabelMarkup]="allowLabelMarkup"
                                             (changeSelections$)="select($event)"></fui-multiselect-options>
                </fui-fragment>
            </fui-fragments>
        </fui-content-section>
        <fui-ftb-section *ngIf="ftb()">
            <fui-fragments>
                <fui-fragment *ngIf="addable || (extendable && options.length > 0)">
                    <fui-buttons>
                        <fui-mark-button (click)="extend()"  *ngIf="options.length > 0 && extendable"
                                         [attr.title]="'fui.common.button.search' | translate"
                                         id="extended-search-button">
                            <fui-icon [height]="12" [icon]="'lookup'" [width]="12"></fui-icon>
                        </fui-mark-button>
                        <fui-mark-button (click)="add()" *ngIf="addable"
                                         [attr.title]="'fui.common.button.addNew' | translate"
                                         id="add-new-button">
                            <fui-icon [height]="12" [icon]="'plus'" [width]="12"></fui-icon>
                        </fui-mark-button>
                    </fui-buttons>
                </fui-fragment>
                <fui-fragment *ngIf="limited()">
                    <fui-limit-total [limit]="filteredOptions.length" [total]="total"></fui-limit-total>
                </fui-fragment>
            </fui-fragments>
        </fui-ftb-section>
    </fui-sections>
</fui-select-pop>
